import ReactDOM from "react-dom";
import Alert from "./Alert";

const CommonModal = ({
  isOpen,
  onClose,
  title = "Change Source",
  children,
  alertIcon,
  alertType,
  showAlert = true,
  hideCloseButton = false,
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-card z-[99999] rounded-md shadow-lg w-full max-w-xl relative px-6 pb-6">
        <div className="pt-6">
          <h2 className="text-lg font-medium text-foreground my-4">{title}</h2>
        </div>

        {showAlert && (
          <Alert
            type={alertType || "warning"}
            text="Changes made here affect how all of your agents think and behave."
            icon={alertIcon}
          />
        )}

        {children}

        {!hideCloseButton && (
          <button
            onClick={onClose}
            className="absolute top-3 right-4 text-muted-foreground hover:text-foreground text-3xl font-semibold"
          >
            &times;
          </button>
        )}
      </div>
    </div>,
    document.body
  );
};

export default CommonModal;
